export default __webpack_public_path__ + "static/media/indoor_poster_blue_original.7333f8d8.jpg";